import { Modal } from "react-bootstrap";
import { ReactComponent as Status } from "../../asset/images/status.svg";

const UpdationConfirmationModal = ({ show, onClose, onUpdate, isLoading }) => {
  return (
    <Modal className="idu-modal" show={show} onHide={onClose} centered>
      <Modal.Body>
        <div className="d-flex flex-column align-items-center unmap-modal-div w-100">
          <Status />

          <span>Update Telecaller User ID?</span>

          <p className="text-center">
            The previous ID will be replaced with the selected one
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="idu-btn-outline w-50"
          type="button"
          onClick={onClose}
        >
          CANCEL
        </button>
        <button
          className="idu-btn-primary w-50"
          type="button"
          onClick={onUpdate}
        >
          {isLoading ? "LOADING..." : "UPDATE"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpdationConfirmationModal;
